import { __assign } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getImageStylesAndSrc } from './helpers';
import ImgZoomable from './ImageZoomable';
import Img from './ImageBase';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import HiddenDumbView from '../../../../DeviationViews/Dumbo/Hidden';
import isNumber from 'lodash/isNumber';
import { ViewerContainerSizeContext } from '../../../ViewerContainerSizeContext/ViewerContainerSizeContext';
var ImageView = function (props) {
    var containerWidth = useContext(ViewerContainerSizeContext);
    var deviation = props.deviation, propsWidth = props.width, config = props.config;
    var showMatureContent = useContext(MatureContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var configuredWidth = propsWidth;
    if (config.width && propsWidth) {
        configuredWidth = config.width < propsWidth ? config.width : propsWidth;
    }
    if ((!showMatureContent && deviation.isMature) ||
        deviation.isBlocked ||
        (deviation.isAntisocial && !isLoggedIn)) {
        // We have extra check for anti-social because inside a saved editor
        // deviation we can have stale isBlocked value
        return (React.createElement(HiddenDumbView, __assign({}, props, { width: isNumber(configuredWidth) ? configuredWidth : 780 })));
    }
    var calculatedProps = getImageStylesAndSrc(deviation, configuredWidth, config, containerWidth);
    if (!calculatedProps) {
        return null;
    }
    var allowFullview = calculatedProps.allowFullview, canBeLinked = calculatedProps.canBeLinked, wrapperStyles = calculatedProps.wrapperStyles, coverThumb = calculatedProps.coverThumb, imgStyles = calculatedProps.imgStyles;
    var ImageComponent = allowFullview && !canBeLinked ? ImgZoomable : Img;
    return (React.createElement("div", { className: classnames(getThumbGlobalClassNames(deviation)), style: wrapperStyles },
        React.createElement(EditorDeviationLink, { link: config.link, deviation: deviation, linkClass: "gallery-link" },
            React.createElement(ImageComponent, { file: coverThumb, deviation: deviation, imgStyles: imgStyles }))));
};
ImageView.displayName = 'ImageView';
export default ImageView;
//# sourceMappingURL=Image.js.map